<template>
  <BjDrawerForm ref="BjDrawerForm" class="view-container" :form="form" :rules="rules" label-width="130px" width="800px" @handleConfirm="handleConfirm">
    <template>
      <BjDivider>{{ $t('BusinessPurchaseSupplierShop.dataForm.title') }}
        <template v-if="isEdit" #right>
          <el-button type="primary" @click="showLog">{{ $t('BusinessPurchaseSupplierShop.dataForm.titleBtn') }}</el-button>
        </template>
      </BjDivider>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('BusinessPurchaseSupplierShop.dataForm.supplier')" prop="supplierId">
            <BjSelectSupplier v-model="form.supplierId" :default-options="{
              label: form.supplierName,
              value: form.supplierId,
            }" :disabled="isEdit" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('BusinessPurchaseSupplierShop.dataForm.week')" prop="deliveryCycleDay">
            <div class="flex-center">
              <el-input-number v-model="form.deliveryCycleDay" :min="0" :label="$t('BusinessPurchaseSupplierShop.dataForm.week')" class="full-width" :controls="false" />
              <span class="ml5">{{ $t('BusinessPurchaseSupplierShop.dataForm.day') }}</span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-col :span="12">
        <BjFormItemCode v-model="form.supplierSpuCode" :label="$t('BusinessPurchaseSupplierShop.dataForm.supplierSpuCode')" prop="supplierSpuCode" />
      </el-col>
      <el-col :span="12">
        <BjFormItemCode v-model="form.supplierSkuCode" :label="$t('BusinessPurchaseSupplierShop.dataForm.supplierSkuCode')" prop="supplierSkuCode" />
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('BusinessPurchaseSupplierShop.dataForm.taxUnitPrice')" prop="taxUnitPrice">
          <el-input-number v-model="form.taxUnitPrice" :min="0" :label="$t('BusinessPurchaseSupplierShop.dataForm.taxUnitPrice')" class="full-width" :controls="false" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('BusinessPurchaseSupplierShop.dataForm.unitPrice')" prop="unitPrice">
          <el-input-number v-model="form.unitPrice" :min="0" :label="$t('BusinessPurchaseSupplierShop.dataForm.unitPrice')" class="full-width" :controls="false" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('BusinessPurchaseSupplierShop.dataForm.taxRate')" prop="taxRate">
          <div class="flex-center">
            <el-input-number v-model="form.taxRate" :min="0" :label="$t('BusinessPurchaseSupplierShop.dataForm.taxRate')" class="full-width" :controls="false" />
            <span class="ml5">%</span>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('BusinessPurchaseSupplierShop.dataForm.minQty')" prop="minQty">
          <el-input-number v-model="form.minQty" :min="0" :label="$t('BusinessPurchaseSupplierShop.dataForm.minQty')" :precision="0" :controls="false" class="full-width" controls-position="right" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('BusinessPurchaseSupplierShop.dataForm.package')" prop="packagingFlag">
          <BjSelectLov v-model="form.packagingFlag" :option-list="STATUS_YES_TRUE" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('BusinessPurchaseSupplierShop.dataForm.shipping')" prop="shippingFlag">
          <BjSelectLov v-model="form.shippingFlag" :option-list="STATUS_YES_TRUE" />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('BusinessPurchaseSupplierShop.dataForm.remark')" prop="remark">
          <BjTextarea v-model="form.remark" :placeholder="$t('BusinessPurchaseSupplierShop.dataForm.remark')" />
        </el-form-item>
      </el-col>
      <BjDivider>{{ $t('BusinessPurchaseSupplierShop.dataForm.productInformation') }}
        <template #right>
          <el-button v-if="!isEdit" type="primary" @click="addGoodsDialog">{{ $t('BusinessPurchaseSupplierShop.dataForm.addCommodity') }}</el-button>
        </template>
      </BjDivider>
      <el-table :data="isEdit ? form.skuVO : form.skuList" border script>
        <el-table-column type="index" :label="$t('table.countText')" width="60" align="center" />
        <el-table-column prop="materialMainImages" :label="$t('BusinessPurchaseSupplierShop.dataForm.picture')" align="center">
          <template slot-scope="{ row }">
            <div class="class=flex flex-center">
              <BjViewUrl :url="(isEdit ? row.spuPic : row.imageUrl)" height="80px" preview />
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="spuCode" :label="$t('goodsPage.spuCode')" align="center"></el-table-column>
        <el-table-column prop="spuName" :label="$t('goodsPage.spuName')" align="center"></el-table-column> -->
        <el-table-column prop="skuCode" :label="$t('BusinessPurchaseSupplierShop.dataForm.sku')" align="center"></el-table-column>
        <el-table-column prop="skuName" :label="$t('BusinessPurchaseSupplierShop.dataForm.skuName')" align="center"></el-table-column>
      </el-table>
      <!-- 选择普通商品 -->
      <BjDialogList ref="dialogListSku" width="80%" :config="
          $BjDialogListConfig.skuDefault(this.$t('BusinessPurchaseSupplierShop.dataForm.addCommodity'), {
            defaultQuery: { setFlag: 0, status: [3, 4, 5] },
          })
        " multiple @confirm="onAddGoodsDialogConfirm" />
    </template>
  </BjDrawerForm>
</template>
<script>
import { purchaseApi } from '@/api';
import { STATUS_YES_TRUE } from '@/utils/constants';
import orderLog from '@/utils/log.js';

const getDefaultForm = () => {
  return {
    deliveryCycleDay: undefined,
    id: null,
    minQty: undefined,
    packagingFlag: null,
    remark: null,
    shippingFlag: null,
    skuList: [],
    supplierId: null,
    supplierSkuCode: null,
    supplierSpuCode: null,
    taxRate: 0,
    taxUnitPrice: undefined,
    unitPrice: undefined,
  };
};

export default {
  data() {
    return {
      STATUS_YES_TRUE,
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
      // 表单校验
      rules: {
        supplierId: [
          {
            required: true,
            message: this.$t('BusinessPurchaseSupplierShop.dataForm.supplierId'),
            trigger: 'change',
          },
        ],
        taxUnitPrice: [
          {
            required: true,
            message: this.$t('BusinessPurchaseSupplierShop.dataForm.taxUnitPriceRule'),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(
        this.isEdit
          ? this.$t('BusinessPurchaseSupplierShop.dataForm.edit')
          : this.$t('BusinessPurchaseSupplierShop.dataForm.add'),
      );
      this.form = Object.assign(getDefaultForm(), info || {});
      if (this.isEdit) {
        this.form.skuVO = [this.form.skuVO];
      }
      const { deliveryCycleDay, minQty } = this.form;
      if (deliveryCycleDay === null) this.form.deliveryCycleDay = undefined;
      if (minQty === null) this.form.minQty = undefined;
    },
    showLog() {
      orderLog(
        this.$BjDialogListConfig['purchaseDefault'](
          `${this.$t('BusinessPurchaseSupplierShop.dataForm.supplier')} （${
            this.form.supplierCode
          }）${this.$t('BusinessPurchaseSupplierShop.dataForm.log')}`,
          {
            defaultQuery: {
              recordId: this.form.id,
              recordType: 'SUPPLER_GOODS',
            },
            search: [],
          },
        ),
      );
    },
    addGoodsDialog() {
      this.$refs['dialogListSku'].show(this.form.skuList);
    },
    // 商品回调
    onAddGoodsDialogConfirm(data) {
      this.form.skuList = data;
    },
    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        API_DATA['_innerMap'] = {};
      } else {
        if (this.form.skuList.length === 0) {
          this.msgError(this.$t('BusinessPurchaseSupplierShop.dataForm.msgError'));
          return;
        }
        API_DATA.skuList = API_DATA.skuList.map(e => {
          return {
            skuCode: e.skuCode,
            skuName: e.skuName,
            spuCode: e.spuCode,
            spuName: e.spuName,
            spuPic: e.imageUrl,
          };
        });
      }
      API_DATA.taxRate = this.$number2money(API_DATA.taxRate);
      this.sendApi(API_DATA);
    },
    reFresh() {
      this.$emit('reFresh');
    },
    sendApi(API_DATA) {
      purchaseApi[(this.isEdit ? 'put' : 'add') + 'SupplierGoodss'](API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
